export default __webpack_public_path__ + "static/media/AnimalsWhite_06.ff30adc4.png";